module.exports = __webpack_public_path__ + "img/view.bd8f8532.jpg";